import './OtpModal.css'

function OtpBackdrop(props) {
  return <div className='backdrop' onClick={() => props.onClick()} />;
}

export default OtpBackdrop;
